import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CiLocationOn } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import { FiMail } from "react-icons/fi";
import Pagination from "./Pagination";
import { testingJobs } from "./tempConstants";

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPge, setPostsPerPage] = useState(5);

  const jobs = [...testingJobs];
  const indexOfLastJob = currentPage * jobsPerPge;
  const indexOfFirstJob = indexOfLastJob - jobsPerPge;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);

  const handlePagination = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page Title */}
      <div className="page-title accent-background">
        <div className="container">
          <h1>Careers</h1>
          <nav className="breadcrumbs">
            <ol>
              <li>
                <Link to="/#home">Home</Link>
              </li>
              <li className="current">Join Our Team</li>
            </ol>
          </nav>
        </div>
      </div>
      {/* Service Details Section */}
      <section id="service-details" className="service-details careersWrapper">
        <div className="container">
          <div className="row gy-12 careersInnerWrapper">
            <div className="col-md-9">
              <h1>Redefine the way the world works.</h1>
              <p>Join the team that's turning this vision into reality.</p>
              {/* <div className="buttonWrapper">
                                <button>Open positions</button>
                            </div> */}
              {!selectedJob && (
                <div className="jobsCardWrapper">
                  <ul>
                    {currentJobs.map((item, index) => {
                      return (
                        <li
                          key={`${item.title}-${index}`}
                          onClick={() => {
                            // eslint-disable-next-line no-restricted-globals
                            scrollTo(0, 0);
                            setSelectedJob(item);
                          }}
                        >
                          <span>
                            {item.title}
                            <i>
                              <CiLocationOn /> {item.location}
                            </i>
                          </span>
                          <div className="emailWrapper">
                            <i><FiMail /></i>
                            <a href="mailto:careers@trbai.com">
                              careers@trbai.com
                            </a>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                  {jobs.length === 0 && (
                    <div className="noJobOpening">
                      No job openings at the moment, but opportunities are
                      always on the horizon! Stay tuned for new roles to join
                      your dream team.
                    </div>
                  )}
                  <Pagination
                    length={Math.ceil(jobs.length / 5)}
                    postsPerPage={jobsPerPge}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                  />
                </div>
              )}

              {selectedJob && (
                <div className="jobDescription">
                  <span
                    className="closeDescription"
                    onClick={() => setSelectedJob(null)}
                  >
                    <RxCross2 />
                  </span>
                  <b style={{ marginTop: "33px", display: "flex" }}>
                    Overview:
                  </b>{" "}
                  <br />
                  <span
                    dangerouslySetInnerHTML={{
                      __html: selectedJob?.description,
                    }}
                  ></span>
                </div>
                // <div className="jobDescription">
                //     <span
                //         className="closeDescription"
                //         onClick={() => setIsDescription(false)}
                //     >
                //         <RxCross2 />
                //     </span>
                //     <JobDetailsPagination />{" "}
                // </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Careers;
